import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import axios from 'axios';
import { client } from '@/services/api/axios.ts';

interface IDeleteUser {
  userId: string | undefined;
}

export async function deleteUser({ userId }: IDeleteUser): Promise<void | unknown> {
  try {
    if (!userId) return;

    const promise = client.delete(`/users/${userId}`);

    const { data } = await toast.promise(
      promise,
      {
        loading: `Deleting user...`,
        success: `Successfully deleted`,
        error: (error: unknown) => {
          let message = error instanceof Error ? error?.message : '';

          if (axios.isAxiosError(error)) {
            message = error?.response?.data?.message;
          }

          return `Failed to delete the user... ${message ? message : ''}`;
        },
      },
      { duration: 3000 }
    );

    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useDeleteUserQuery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUser,
    onSettled: () => {
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ['users'] });
      }, 300);
    },
  });
};
